import merge from 'lodash/merge';
import {getWindow} from 'ssr-window';
import DOMUtils from '@spothero/utils/dom';
import EnvironmentUtils from '@spothero/utils/environment';

const window = getWindow();
const apiDateFormat = 'YYYY-MM-DD';
const currencyFormat = '$0,0';

const renderRecaptcha = recaptchaSiteKey => {
    window.grecaptcha.render(DOMUtils.el('.g-recaptcha'), {
        sitekey: recaptchaSiteKey,
    });
};

const Config = {
    // local
    isMobile: EnvironmentUtils.isMobileDevice(),
    apiDateFormat,
    apiDateTimeFormat: `${apiDateFormat}THH:mm`,
    appStoreLink: 'http://itunes.apple.com/us/app/spothero/id499097243?mt=8',
    basename: '/',
    craigUrl: 'https://api.spothero.com/v2',
    currencyFormat,
    currencyFormatExtended: `${currencyFormat}.00`,
    displayDateFormat: 'MM/DD/YYYY',
    displayEventDateFormat: 'dddd, MMM D, YYYY [at] h:mm a',
    facilityIncludes:
        'inventory_availability,facility,facility.amenities_full,facility.details,facility.images,facility.vehicle_size,facility.oversize_description,facility.transient_available,facility.monthly_available,facility.vehicle_restriction_description,facility.oversize_vehicle_type,facility.rating_info,facility.facility_url,facility.supported_fee_types,facility.operator_id',
    integerFormat: '0,0',
    metaLogoUrl:
        'https://res.cloudinary.com/spothero/image/upload/v1513282776/consumer-web-spa/spothero-logo-share.jpg',
    militaryTimeFormat: 'HH:mm',
    playStoreLink:
        'https://play.google.com/store/apps/details?id=com.spothero.spothero',
    serviceAPIUrl: 'https://services.production.spothero.com',
    spotHeroAPIUrl: '/api/v1',
    standardTimeFormat: 'hh:mm A',
    urlDateFormat: 'MM-DD-YYYY',
    clientIPAddress: null,
    staticBaseUrl: '/',
    isBot: !EnvironmentUtils.isBrowser()
        ? false
        : window.navigator.userAgent.trim().length < 3
        ? true
        : /bot|slurp|ios-native|android-native|crawler|spider|crawling|python-requests|http-kit|scrapy|stripe/i.test(
              window.navigator.userAgent
          ),
    infoPanelCookie: 'sh-hide-info-panel',
    release: null,
    // from config endpoint
    branchIOApiKey: null,
    facebookAppId: '171344769571965',
    facebookChannelUrl: null,
    googleMapsApiKey: null,
    isDeployed: false,
    isProduction: false,
    mobileDateFormat: apiDateFormat,
    mobilePaginationLimit: 30,
    recaptchaSitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    sentryApiPublicKey:
        'https://86fa92571fdb4aea90ec328ff01e3885@sentry.io/1186698',
    siteUrl: 'https://spothero.com',
    stripePublicApiKey: 'pk_test_61W6KdctVrYTI4UzY1tvfUUv',
    isSegmentEnabled: false,
    segmentApiKey: 'DSBO42HVekfwO1joUX2uQ9h1kJDEzJKv',
    citySlugs: [],
    cloudfrontViewerCountryCode: 'US',
    gtmAccount: 'GTM-5VQ7Z4',
    googleOAuth2Id:
        '591846304453-c68jdn8j5tr346me9emk9jfc20g4rt3d.apps.googleusercontent.com',
    redirectCacheTTL: 5 * 60,
    redirectCacheRefreshInterval: 4 * 60,

    set(opts) {
        merge(this, opts);
    },

    async initRecaptcha() {
        if (Config.isProduction) {
            if (!window.grecaptcha) {
                try {
                    await DOMUtils.loadScript({
                        src:
                            'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoaded&render=explicit',
                        appendTo: 'body',
                    });

                    window.onRecaptchaLoaded = () => {
                        renderRecaptcha(Config.recaptchaSitekey);
                    };
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.log('Could not load Google Recaptcha:', error);
                }
            } else {
                renderRecaptcha(Config.recaptchaSitekey);
            }
        }
    },
};

export default Config;
